import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const roTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: 'Nume (minuscule, fără caractere speciale)',
    add: 'Adăugați',
    allowedFileTypes: 'Tipuri de fișiere permise',
    allowedFileTypesDescription:
      'Restricționați tipurile de fișiere permise (de exemplu, imagine/*, aplicație/pdf). Lăsați gol pentru a permite toate tipurile.',
    allowMultipleFiles: 'Permite mai multe fișiere',
    amountInCents: 'Suma în cenți',
    basePrice: 'Prețul de bază',
    bcc: 'BCC',
    brand: 'Marca',
    cc: 'CC',
    checkboxPlural: 'Caseta de selectare Câmpuri',
    checkboxSingular: 'Caseta de selectare',
    checkedByDefault: 'Bifat implicit',
    chooseConfirmationType:
      'Alegeți dacă doriți să afișați un mesaj pe pagină sau să redirecționați către o altă pagină după ce trimit formularul.',
    condition: 'Stare',
    confirmationMessage: 'Mesaj de confirmare',
    confirmationType: 'Tip de confirmare',
    countryPlural: 'Câmpuri de țară',
    countrySingular: 'Țara',
    creditCard: 'Card de credit',
    customURL: 'Adresă URL personalizată',
    datePlural: 'Câmpurile de dată',
    dateSingular: 'Data',
    defaultValue: 'Valoare implicită',
    divide: 'Împărțiți',
    documentToLinkTo: 'Document la care să faceți legătura',
    doesNotEqual: 'Nu este egal',
    emailFrom: 'E-mail de la',
    emailPlural: 'Câmpuri de e-mail',
    emailsDescription:
      'Trimiteți e-mailuri personalizate când se trimite formularul. Utilizați liste separate prin virgulă pentru a trimite același e-mail către mai mulți destinatari. Pentru a face referire la o valoare din acest formular, includeți numele câmpului respectiv cu paranteze duble, adică {{firstName}}. Puteți folosi un metacar {{*}} pentru a scoate toate datele și {{*:table}} pentru a le formata ca tabel HTML în e-mail.',
    emailSingular: 'E-mail',
    emailTo: 'E-mail către',
    equals: 'Egal',
    field: 'Câmp',
    fields: 'Câmpuri',
    fieldWidth: 'Lățimea câmpului (procent)',
    hasAnyValue: 'Are orice valoare',
    internalLink: 'Legătură internă',
    label: 'Etichetă',
    maxFileSize: 'Dimensiunea maximă a fișierului (octeți)',
    maxFileSizeDescription: 'Dimensiunea maximă a fișierului în octeți. Lăsați gol fără limită.',
    message: 'Mesaj',
    messageDescription: 'Introduceți mesajul care ar trebui trimis în acest e-mail.',
    messagePlural: 'Blocuri de mesaje',
    messageSingular: 'Mesaj',
    mimeType: 'Tip MIME',
    mimeTypePlural: 'Tipuri MIME',
    mimeTypeSingular: 'Tip MIME',
    multiply: 'Înmulțiți',
    numberPlural: 'Câmpuri numerice',
    numberSingular: 'Număr',
    optionPlural: 'Opțiuni',
    optionSingular: 'Opțiune',
    paymentFieldPlural: 'Câmpuri de plată',
    paymentFieldSingular: 'Plata',
    paymentProcessor: 'Procesor de plăți',
    paymentStatus: 'Stare',
    placeholder: 'Substituent',
    priceConditions: 'Conditii de pret',
    priceConditionsPlural: 'Conditii de pret',
    priceConditionsSingular: 'Condiția prețului',
    radioOptions: 'Opțiuni de atribut radio',
    radioPlural: 'Câmpuri radio',
    radioSingular: 'Radio',
    redirect: 'Redirecționează',
    replyTo: 'Răspunde la',
    required: 'Obligatoriu',
    selectOptions: 'Selectați Opțiuni',
    selectPlural: 'Selectați Câmpuri',
    selectSingular: 'Selectați',
    statePlural: 'Câmpuri de stat',
    stateSingular: 'de stat',
    staticValue: 'Valoare statică',
    subject: 'Subiect',
    submitButton: 'Trimiteți eticheta butonului',
    subtract: 'Scăderea',
    textareaPlural: 'Câmpuri de zonă de text',
    textareaSingular: 'Textarea',
    textPlural: 'Câmpuri de text',
    textSingular: 'Text',
    title: 'Titlu',
    token: 'jeton',
    uploadCollection: 'Încărcați colecția',
    uploadCollectionDescription: 'Selectați în ce colecție de încărcare să stocați fișierele',
    uploadFieldPlural: 'Încărcați câmpuri',
    uploadFieldSingular: 'Încărcați',
    urlToRedirectTo: 'URL către care să redirecționeze',
    value: 'Valoare',
    valueOfField: 'Valoarea câmpului',
    valueType: 'Tip de valoare',
  },
}

export const ro: PluginLanguage = {
  dateFNSKey: 'ro',
  translations: roTranslations,
}
